module.exports = __webpack_public_path__ + "static/media/film.cb10b576.svg";